import script from "./TagIconValue.vue?vue&type=script&setup=true&lang=js"
export * from "./TagIconValue.vue?vue&type=script&setup=true&lang=js"

import "./TagIconValue.vue?vue&type=style&index=0&id=0f697be2&lang=scss"

const __exports__ = script;

export default __exports__